import React, { useContext } from 'react';
import { FileInvoiceDollar } from '@styled-icons/fa-solid';
import styled from 'styled-components';

import { InvoicesTable } from 'pages/Settings/SettingsPage/SettingsInvoices/InvoicesTable';
import { useGetInvoicesQuery } from 'data/__generated__';

import { Loading } from 'components/Loading';

import { UserContext } from 'constants/user-context';

import {
    SettingsTitleContainerWrapper,
    SettingsTitleContainer,
    SettingsTitle,
    SettingsCardSubtitle,
    SettingsPageStyle,
    SettingsCard,
} from 'styles/pages/settings.styles';

export const SettingsPageInvoices: React.FC = () => {
    const {
        organization: { _id: organizationId },
    } = useContext(UserContext) as {
        organization: {
            _id: string;
        };
    };
    const {
        loading: invoicesLoading,
        error: invoicesError,
        data: invoicesData,
        fetchMore: fetchMoreInvoices,
    } = useGetInvoicesQuery({
        variables: { organizationId },
        notifyOnNetworkStatusChange: true,
    });

    if (invoicesError) {
        throw invoicesError;
    }

    return (
        <SettingsPageStyle>
            <SettingsCard>
                <SettingsTitleContainerWrapper>
                    <SettingsTitleContainer>
                        <FileInvoiceDollar />
                        <SettingsTitle>Mes factures</SettingsTitle>
                    </SettingsTitleContainer>
                </SettingsTitleContainerWrapper>
                <SettingsCardSubtitle>Commandes e-store</SettingsCardSubtitle>
                {invoicesLoading && !invoicesData ? (
                    <Loading relative />
                ) : invoicesData?.getInvoices?.invoices ? (
                    <InvoicesTable
                        invoices={invoicesData?.getInvoices.invoices}
                        organizationId={organizationId}
                        hasMore={invoicesData?.getInvoices.hasMore}
                        isLoading={invoicesLoading}
                        fetchMore={fetchMoreInvoices}
                    />
                ) : (
                    <ErrorMessage>Il y a eu un souci lors de la récupération de vos factures.</ErrorMessage>
                )}
            </SettingsCard>
        </SettingsPageStyle>
    );
};

const ErrorMessage = styled.p`
    color: ${({ theme }) => theme.colors.red};
`;
